// extracted by mini-css-extract-plugin
module.exports = {"container":"Balloon_container__2oFcb","ball":"Balloon_ball__uEHNQ"};